// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"LoginButton_loginButton__1FWNL","loginButtonLight":"LoginButton_loginButtonLight__2wXzf","loginButtonDark":"LoginButton_loginButtonDark__1dj1O"};